import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Prior to starting a historical data migration, ensure you do the following:`}</p>
      <ol parentName="blockquote">
        <li parentName="ol">{`Create a project on our `}<a parentName="li" {...{
            "href": "https://us.posthog.com/signup"
          }}>{`US`}</a>{` or `}<a parentName="li" {...{
            "href": "https://eu.posthog.com/signup"
          }}>{`EU`}</a>{` Cloud.`}</li>
        <li parentName="ol">{`Sign up to a paid product analytics plan on `}<a parentName="li" {...{
            "href": "https://us.posthog.com/organization/billing"
          }}>{`the billing page`}</a>{` (historic imports are free but this unlocks the necessary features).`}</li>
        <li parentName="ol">{`Set the `}<inlineCode parentName="li">{`historical_migration`}</inlineCode>{` option to `}<inlineCode parentName="li">{`true`}</inlineCode>{` when capturing events in the migration. This is automated if you are running a `}<a parentName="li" {...{
            "href": "/docs/migrate/managed-migrations"
          }}>{`managed migration`}</a>{`.`}</li>
      </ol>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      